import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isHeader", "title"];
import React, { forwardRef } from 'react';
import TableCell from './TableCell';
import TableRowHeader from './TableRowHeader';
var TableBodyCell = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    isHeader = _ref.isHeader,
    title = _ref.title,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (isHeader) {
    return /*#__PURE__*/React.createElement(TableRowHeader, _extends({}, otherProps, {
      ref: ref
    }), children);
  }
  return /*#__PURE__*/React.createElement(TableCell, _extends({}, otherProps, {
    ref: ref,
    "data-columnheader": title
  }), children);
});
TableBodyCell.displayName = 'TableBodyCell';
export default TableBodyCell;